export default __webpack_public_path__ + "static/indoor14-6af0fdc42c1637fe0e1f5aff6f287fe7.webp";